<div class="items-banner" *ngIf="heldCount > 0 || checkedOutCount > 0" data-automation-id="checked-and-held-items-banner">
  <button class="items-banner__button" *ngIf="heldCount > 0" (click)="goToHolds()" data-automation-id="held-items-banner-button">
    {{ 'youHaveCopiesOnHold' | translate: {heldCount} }}
  </button>
  <button class="items-banner__button" *ngIf="checkedOutCount > 0" (click)="goToCheckouts()" data-automation-id="checked-out-items-banner-button">
    {{ 'youHaveCopiesCheckedOut' | translate: {checkedOutCount} }}
  </button>
</div>
